import React from "react";
import Page from "components/Page";
import { Props } from "./Documents";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Documents = lazyWithRetry(() => import("./Documents"));

export default (props: Props) => (
  <Page>
    <Documents {...props} />
  </Page>
);
